import { UploadFile } from '@mui/icons-material';
import { Button } from '@mui/material';
import SquaresWorkOrdersManagementHandler from 'handlers/squaresHandlers/sqauresWorkOrdersManagement.handler';
import { useState } from 'react';
import { ImportModal } from '../../components/UploadModal';
import { useTranslation } from 'react-i18next';

export const ImportButton = () => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const workOrdersManagementHandler = new SquaresWorkOrdersManagementHandler();

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleImportProceed = async (file: File) => {
    try {
      const response = await workOrdersManagementHandler.importWorkOrder({
        file,
        workflowType: 'work_order_request',
      });
      await workOrdersManagementHandler.getAllWorkOrders();
      return response;
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        size="small"
        onClick={handleOpenModal}
        sx={{
          textTransform: 'none',
        }}
        startIcon={<UploadFile />}
      >
        {t('boundary_importer_btn_import')}
      </Button>
      {
        <ImportModal
          open={isModalOpen}
          onClose={handleCloseModal}
          onProceed={handleImportProceed}
        />
      }
    </>
  );
};
